<template>
    <RentalMessage :rental="message.rental" :date="message.created_at">
        <Spinner v-if="loading" size="medium" line-fg-color="#000" line-bg-color="#fb0"/>
        <div v-else>
            <TooliabaButton :enabled="isActiveRequest" @click="onButtonClick('accept')" class="mb2">Accept</TooliabaButton>
            <BlackButton :enabled="isActiveRequest" @click="onButtonClick('decline')">Decline</BlackButton>
            <RequestTimer v-if="isActiveRequest"/>
        </div>
    </RentalMessage>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import RentalMessage from '@/components/inbox/messagesCard/shared/RentalMessage.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import RequestTimer from '@/components/inbox/messagesCard/shared/RequestTimer.vue';
import { mapActions } from 'vuex';

export default {
    components: {
        Spinner,
        RentalMessage,
        BlackButton,
        TooliabaButton,
        RequestTimer
    },
    data() {
        return {
            loading: false
        };
    },
    props: {
        message: {
            type: Object
        }
    },
    methods: {
        ...mapActions('messages', ['setRentalState']),
        onButtonClick(rentalState) {
            this.loading = true;
            this.setRentalState({
                id: this.message.rental.id,
                state: rentalState
            }).then(() => {
                this.message.rental.state = null;
                this.loading = false;
            });
        }
    },
    computed: {
        isActiveRequest() {
            return this.message.rental.state === 'requested';
        }
    }
};
</script>
